module.exports = __webpack_public_path__ + "images/join-bg.png";